import { render, staticRenderFns } from "./logo_sologan.vue?vue&type=template&id=0c7745c8&scoped=true"
import script from "./logo_sologan.vue?vue&type=script&lang=js"
export * from "./logo_sologan.vue?vue&type=script&lang=js"
import style0 from "./logo_sologan.vue?vue&type=style&index=0&id=0c7745c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7745c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
